var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { KeyCode } from '../../../../core/utils/src/dom';
import debounce from '../../../../core/utils/src/debounce';
import InputController from './input-controller';
var AutoSuggestController = /** @class */ (function (_super) {
    __extends(AutoSuggestController, _super);
    function AutoSuggestController(component, node) {
        var _this = _super.call(this, component, node) || this;
        _this.component = component;
        _this.node = node;
        // Calculates a key with the option's value and label that is used to track the highlighted item,
        // even when the list of options has been flushed completely.
        _this.optionsAttributeChangeHandler = function (options) {
            var getHighlightKey = function (option) { return (option ? option.value + "-" + option.label : null); };
            var highlighted = _this.component.getHighlightedOption();
            if (!highlighted || !options) {
                _this.component.setHighlightedOption(null);
                return;
            }
            var searchKey = getHighlightKey(highlighted);
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var option = options_1[_i];
                if (getHighlightKey(option) === searchKey) {
                    _this.component.setHighlightedOption(option);
                    break;
                }
            }
        };
        // Receive the component's input event and schedule it for the next delayedInput event
        _this.valueUpdateHandler = function (newValue) {
            _super.prototype.valueUpdateHandler.call(_this, newValue);
            _this.component.openDropdown();
            _this.component.resetDropdownScroll();
            _this.component.setHighlightedOption(null);
            _this.notifyDelayedInput();
        };
        _this.notifyDelayedInput = debounce(function () { return _this.component.notifyDelayedInput(); });
        _this._selectionListener = function (e) { return _this.selectionListener(e); };
        _this._globalMousedownListener = function (e) { return _this.globalMousedownListener(e); };
        return _this;
    }
    AutoSuggestController.prototype.addListeners = function () {
        _super.prototype.addListeners.call(this);
        // Close the dropdown when the user clicks away
        this.node.ownerDocument.addEventListener('mousedown', this._globalMousedownListener);
        // Handle selection handler from option
        this.node.addEventListener('awsui:__selected', this._selectionListener);
    };
    AutoSuggestController.prototype.removeListeners = function () {
        _super.prototype.removeListeners.call(this);
        this.node.ownerDocument.removeEventListener('mousedown', this._globalMousedownListener);
        this.node.removeEventListener('awsui:__selected', this._selectionListener);
    };
    AutoSuggestController.prototype.changeListener = function (option, force) {
        if (this.clickWasOutsideInput && !option) {
            return;
        }
        var value = this.component.getValue();
        if (force || value !== this.confirmedValue) {
            this.confirmedValue = value;
            this.component.notifyChange(value, option);
        }
    };
    AutoSuggestController.prototype.selectionListener = function (ev) {
        var _this = this;
        ev.stopPropagation();
        this.component.setSelectedOption(ev.detail, function () { return _this.afterSelected(ev.detail); });
    };
    AutoSuggestController.prototype.afterSelected = function (option) {
        this.valueUpdateHandler(option.value);
        // Override confirmedValue check, so that change is always fired when an option is selected.
        // It's not entirely clear if this is strictly expected behaviour (e.g. if you select the same
        // option repeatedly), but it is existing behaviour, and is relied upon in table property filtering.
        this.changeListener(option, true);
        // This makes sure that the input value is set before returning the focus, otherwise it might still be
        // empty when focusing and therefore keep the dropdown open.
        this.component.focus();
        this.component.closeDropdown();
    };
    AutoSuggestController.prototype.focusListener = function (e) {
        if (this.eventTargetIsInput(e)) {
            _super.prototype.focusListener.call(this, e);
            if (!this.component.getValue() || this.component.shouldOpenOnFocus()) {
                this.component.openDropdown();
            }
        }
    };
    AutoSuggestController.prototype.blurListener = function (e) {
        if (this.eventTargetIsInput(e)) {
            _super.prototype.blurListener.call(this, e);
        }
    };
    AutoSuggestController.prototype.moveHighlight = function (dir) {
        var options = this.component.getEnabledOptions();
        if (options.length === 0) {
            return;
        }
        var currIdx = options.indexOf(this.component.getHighlightedOption());
        var nextIdx = currIdx + dir;
        if (options[nextIdx]) {
            this.component.setHighlightedOption(options[nextIdx]);
        }
        else if (nextIdx === -1) {
            // moved back up into the input field
            this.component.setHighlightedOption(null);
        }
    };
    AutoSuggestController.prototype.keydownListener = function (ev) {
        var _this = this;
        var component = this.component;
        switch (ev.keyCode) {
            default:
                break;
            case KeyCode.enter:
            case KeyCode.space:
                if (component.isDropdownOpen()) {
                    var highlightedOption_1 = this.component.getHighlightedOption();
                    if (highlightedOption_1) {
                        ev.preventDefault();
                        component.setSelectedOption(highlightedOption_1, function () { return _this.afterSelected(highlightedOption_1); });
                    }
                    else if (ev.keyCode === KeyCode.enter) {
                        // commit current value, even if it's not a suggested option
                        ev.preventDefault();
                        component.closeDropdown();
                        this.changeListener();
                    }
                }
                break;
            case KeyCode.tab:
            case KeyCode.escape:
                component.closeDropdown();
                return;
            case KeyCode.up:
            case KeyCode.down:
                ev.preventDefault();
                if (component.isDropdownOpen()) {
                    this.moveHighlight(ev.keyCode === KeyCode.up ? -1 : 1);
                }
                else {
                    component.openDropdown();
                }
                return;
        }
        this.sendKeyEvent(ev);
    };
    AutoSuggestController.prototype.globalMousedownListener = function (ev) {
        if (!this.node.contains(ev.target)) {
            this.component.closeDropdown();
        }
    };
    return AutoSuggestController;
}(InputController));
export default AutoSuggestController;
//# sourceMappingURL=autosuggest-controller.js.map